import { useNavigate, useLocation } from "react-router-dom";

export function useRouterTabs<T extends string>(
  tabPaths: Record<T, string>,
  defaultTab: T
) {
  const navigate = useNavigate();
  const location = useLocation();

  const entries = Object.entries(tabPaths) as [T, string][];

  const found = entries.find(([, path]) => location.pathname.startsWith(path));

  const activeValue = (found?.[0] ?? defaultTab) as T;

  const onChange = (value: T) => {
    const path = tabPaths[value];
    if (path) navigate(path);
  };

  return { activeValue, onChange };
}
